import CrossfadeImage from "react-crossfade-image";
import LiveButton from "../buttons/live";
import StopButton from "../buttons/stop";
import SwitcherButton from "../buttons/switcher";
import MobileNowPlaying from "../nowPlaying/mobile";

export default function MobileView(props) {
  return (
    <section id="mobile" onLoad={() => props.setTicking(true)}>
      {props.nowPlaying?.art && (
        <CrossfadeImage
          src={props.nowPlaying?.art}
          alt={
            "The artwork of " +
            props.nowPlaying?.title +
            " by " +
            props.nowPlaying?.artists
          }
          containerClass="background animated"
          style={{ width: "100%", height: "100%" }}
        />
      )}
      <ul className="container">
        <MobileNowPlaying
          nowPlaying={props.nowPlaying}
          djCount={props.djCount}
          oldDJ={props.oldDJ}
          dj={props.dj}
        />
        <LiveButton
          state={props.state}
          setState={props.setState}
          noSleep={props.noSleep}
          showStations={props.showStations}
          audioUrl={props.audioUrl}
          setAudioUrlState={props.setAudioUrlState}
        />
        <StopButton
          setAudioUrlState={props.setAudioUrlState}
          state={props.state}
          setState={props.setState}
          noSleep={props.noSleep}
          showStations={props.showStations}
        />
        <SwitcherButton
          setShowStations={props.setShowStations}
          showStations={props.showStations}
          station={props.station}
        />
      </ul>
    </section>
  );
}
